import { Route, Switch, Redirect } from "react-router-dom";

import PrivateRoutes from "./routing/PrivateRoutes";
import PrivateRoute from "./auth/PrivateRoute";
import PublicRoute from "./auth/PublicRoute";
import NoMatch from "./pages/NoMatch";

import ForgotPassword from "./auth/password/ForgotPassword";
import ChangePassword from "./auth/password/ChangePassword";
import EmailSentPage from "./auth/password/EmailSentPage";
import AccountVerifed from "./pages/auth/AccountVerified";
import VerifyAccount from "./pages/auth/VerifyAccount";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";

import "../styles/app.scss";

function App() {
  return (
    <div className="App flex-rows">
      <Switch>
        {/* Public routes that don't require authentication */}
        <Route path="/register" component={Register} />
        <Route path="/login/forgot-password" component={ForgotPassword} />
        <Route
          path="/login/change-password/:token"
          component={ChangePassword}
        />
        <Route path="/login/email-verification" component={EmailSentPage} />
        <Route path="/login/verify-email/:encoded" component={AccountVerifed} />
        <Route path="/login/verify-account" component={VerifyAccount} />

        {/* Login route with restricted access */}
        <PublicRoute restricted path="/login" component={Login} />

        <Redirect exact from="/" to="/login" />

        <PrivateRoute path="/">
          <PrivateRoutes />
        </PrivateRoute>

        <Route component={NoMatch} />
      </Switch>
    </div>
  );
}

export default App;
